/**
 * @CL Collection Facet Filters Modifications
 */
(function () {

  const CONFIG = {
    selectors: {
      filterForm: '.cc-facet-filters',
      openFilters: '.cc-filter.is-open',
      closedFilters: '.cc-filter:not(.is-open)',
      dayFilterLabels: '.cc-filter[data-label="day"] .cc-filter__content .cc-filter-label',
      filterToggles: '.cc-filter__toggle'
    },
    breakpoints: {
      desktop: 767.98
    },
    throttleTime: 250
  };

  // State
  let facetInstance = null;
  let resizeTimeout;

  /**
   * tasks to run once on initialization
   * @param {Object} instance - The facet filter instance
   */
  function initialize(instance) {
    facetInstance = instance;
    bindEvents();
    handleResize();

    // intercept filter clicks
    blockFilterClicksOnToggles();
  }

  /**
   * Set up all event listeners
   */
  function bindEvents() {
    // Resize event with throttling
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(handleResize, CONFIG.throttleTime);
    });
  }

  /**
   * Handle window resize events
   * Toggle filter visibility based on screen size
   */
  function handleResize() {
    const isDesktop = window.innerWidth > CONFIG.breakpoints.desktop;
    const filterForm = document.querySelector(CONFIG.selectors.filterForm);

    if (filterForm && filterForm.dataset.filterPosition === 'plp-filter--left' && facetInstance) {
      if (!isDesktop) {
        // Mobile view - close all filters
        const openFilters = facetInstance.form.querySelectorAll(CONFIG.selectors.openFilters);
        openFilters.forEach(filter => {
          filter.classList.remove('is-open');
          if (filter.hasAttribute('open')) {
            filter.removeAttribute('open');
          }
        });
      } else {
        // Desktop view - open all filters
        const closedFilters = facetInstance.form.querySelectorAll(CONFIG.selectors.closedFilters);
        closedFilters.forEach(filter => {
          filter.classList.add('is-open');
          filter.open = true;
        });
      }
    }
  }


  /**
   * Intercept and block clicks on list filters toggles
   */
  function blockFilterClicksOnToggles() {

    let enableCapture = true; //enables capturing phase

    document.addEventListener('click', function(event) {
      // only block clicks on desktop
      if (window.innerWidth > CONFIG.breakpoints.desktop) {
        const filter = event.target.closest('.cc-filter');

        // Only block clicks on filter toggles
        if (filter && event.target.closest('.cc-filter__toggle')) {
          // only Block clicks on filters with data-type="list"
          if (filter.dataset.type === 'list') {
            event.stopPropagation();
            event.preventDefault();

            // Always keep list filters open on desktop
            filter.classList.add('is-open');
            filter.open = true;
          }
        }
      }

    }, enableCapture); // Keep the capturing phase
  }

  // Initialize when facet filters are ready
  document.addEventListener('FacetFilter:initialized', function (e) {
    initialize(e.detail.instance);
  });
})();